"use strict";
/*
 * Created on 5. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Superclass for rounded product prices.
 * @author Radek Beran
 */


var RoundedProductPrice =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(RoundedProductPrice, _DomainObject_1$Domai);

  /**
   * @param value value of price
   * @param valueRounded value of the price rounded according to rounding rules
   */
  function RoundedProductPrice(value, valueRounded) {
    var _this;

    _classCallCheck(this, RoundedProductPrice);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RoundedProductPrice).call(this));
    _this.value = value;
    _this.valueRounded = valueRounded;
    return _this;
  }
  /**
   * Returns price value presented to user. Either returns rounded value (if available), or not rounded value.
   */


  _createClass(RoundedProductPrice, [{
    key: "getPresentedValue",
    value: function getPresentedValue() {
      return this.valueRounded || this.value;
    }
  }]);

  return RoundedProductPrice;
}(DomainObject_1.DomainObject);

exports.RoundedProductPrice = RoundedProductPrice;

RoundedProductPrice.roundedPriceSchema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(RoundedProductPrice.name);
  return {
    value: builder.opt(builder.bigNum('value')),
    valueRounded: builder.opt(builder.bigNum('valueRounded'))
  };
}();